import React, { useState } from 'react';
import classnames from 'classnames';
import ObjectUtil from '@leverege/object-util';
import isEqual from 'lodash.isequal';
import PendingSaleMessage from '../screens/PendingSaleMessage';
import SearchRecipients from '../../../alerts/views/SearchRecipients';
import RecovrSales from '../../../util/RecovrSales';
import C from '../Constants';
import S from './BulkVehicleOnly.css';
import { jsx as _jsx } from "react/jsx-runtime";
const PENDING_SALE_MESSAGE_TITLE = 'Send SMS About This Sale';
const TITLES_BY_SALE_TYPE = {
  [C.SALE_TYPES.DEALER_TRADE]: 'Dealer Trade',
  [C.SALE_TYPES.VEHICLE_ONLY]: 'Vehicle Only Sale',
  [C.SALE_TYPES.VEHICLE_WHOLESALE]: 'Vehicle Wholesale'
};
export default function PendingSale(props) {
  const {
    actions: pActions,
    vehicles,
    saleData,
    saleId,
    saleType,
    onClose,
    onChange
  } = props;
  const state = useState({});
  const [currentStepId, setCurrentStepId] = useState('pending-sale-message');
  const selectionLimit = 5;
  const goToStep = stepId => () => {
    setCurrentStepId(stepId);
  };
  const onPendingSaleMessageSubmit = async () => {
    await RecovrSales.sendPendingSaleMessage({
      saleId,
      recipients: state[0].pendingSaleMessageRecipients.map(value => typeof value === 'object' ? ObjectUtil.pick(['id', 'username', 'email', 'phone'], value) : value),
      message: state[0].pendingSaleMessage,
      actions: pActions
    });
    onClose();
  };
  const onPendingSaleMessageUserListCancel = () => {
    goToStep('pending-sale-message')();
  };
  const onPendingSaleMessageUserListSubmit = () => {
    state[1](s => ({
      ...s,
      pendingSaleMessageRecipients: s.pendingSaleMessageRecipientsTmp
    }));
    goToStep('pending-sale-message')();
  };
  const onAddRecipient = () => {
    goToStep('pending-sale-message-user-list')();
  };
  const onRemoveRecipient = ({
    data
  }) => {
    state[1](s => ({
      ...s,
      pendingSaleMessageRecipients: s.pendingSaleMessageRecipients.filter(r => r !== data)
    }));
  };
  const steps = {
    'pending-sale-message': {
      submitText: 'Send SMS',
      submitDisabled: !state[0]?.pendingSaleMessageRecipients?.length,
      cancelText: 'Cancel',
      onSubmit: onPendingSaleMessageSubmit,
      onCancel: onClose,
      contentClassName: classnames(S.pendingSaleMessageContent),
      content: () => /*#__PURE__*/_jsx(PendingSaleMessage, {
        ...saleData,
        saleType: saleType,
        vehicles: vehicles,
        onChange: onChange,
        onAdd: onAddRecipient,
        onRemove: onRemoveRecipient,
        state: state
      })
    },
    'pending-sale-message-user-list': {
      submitText: 'Apply',
      onSubmit: onPendingSaleMessageUserListSubmit,
      submitDisabled: isEqual(state[0]?.pendingSaleMessageRecipientsTmp, state[0]?.pendingSaleMessageRecipients),
      cancelHidden: true,
      onCancel: onClose,
      headerClassName: classnames(S.headerClassName),
      contentClassName: classnames(S.pendingSaleMessageContent),
      content: () => /*#__PURE__*/_jsx(SearchRecipients, {
        ...saleData,
        actions: pActions,
        saleType: saleType,
        vehicles: vehicles,
        onChange: onChange,
        onCancel: onPendingSaleMessageUserListCancel,
        state: state,
        selectionLimit: selectionLimit,
        searchPhones: true,
        searchUsers: true
      })
    }
  };
  const title = currentStepId === 'pending-sale-message' ? PENDING_SALE_MESSAGE_TITLE : TITLES_BY_SALE_TYPE[saleType];
  const icon = null;
  const currentStep = steps[currentStepId] || {};
  return {
    title,
    icon,
    currentStep
  };
}